import type { HistorySourceTypeConfig } from "./history-source-config";
import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryGroupBy } from "./history-fields";

export const reportSettingsSources: HistorySourceTypeConfig[] = [
    APIProcessName.REPORT_SETTINGS_UPDATE,
    APIProcessName.REPORT_SETTINGS_TEMPLATE_APPLY,
    APIProcessName.REPORT_SETTINGS_TEMPLATE_REMOVE,
].map((sourceType) => ({
    sourceType,
    resourceTypeConfigs: [
        {
            resourceType: ResourceType.REPORT_SETTINGS,
            fields: [],
        },
    ],
    groupBy: HistoryGroupBy.SOURCE_COUNT_DISTINCT,
    platformTwins: null,
    enabled: true,
}));
